import api from './axios';

/**
 * Get all vendors with optional filters
 * @param {object} filters - { search, status }
 * @returns {Promise}
 */
export const getVendors = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.search) params.append('search', filters.search);
  if (filters.status && filters.status !== 'all') params.append('status', filters.status);

  const response = await api.get(`/api/vendors?${params.toString()}`);
  return response.data;
};

/**
 * Get vendor statistics
 * @returns {Promise}
 */
export const getVendorStats = async () => {
  const response = await api.get('/api/vendors/stats');
  return response.data;
};

/**
 * Get a single vendor by ID
 * @param {number} vendorId - Vendor ID
 * @returns {Promise}
 */
export const getVendor = async (vendorId) => {
  const response = await api.get(`/api/vendors/${vendorId}`);
  return response.data;
};

/**
 * Create a new vendor
 * @param {object} vendorData - Vendor data
 * @returns {Promise}
 */
export const createVendor = async (vendorData) => {
  const response = await api.post('/api/vendors', vendorData);
  return response.data;
};

/**
 * Update a vendor
 * @param {number} vendorId - Vendor ID
 * @param {object} vendorData - Vendor data
 * @returns {Promise}
 */
export const updateVendor = async (vendorId, vendorData) => {
  const response = await api.put(`/api/vendors/${vendorId}`, vendorData);
  return response.data;
};

/**
 * Delete a vendor
 * @param {number} vendorId - Vendor ID
 * @returns {Promise}
 */
export const deleteVendor = async (vendorId) => {
  const response = await api.delete(`/api/vendors/${vendorId}`);
  return response.data;
};

/**
 * Assign a job to a vendor (create work log)
 * @param {object} jobData - Job data { vendor_id, job_type, description, start_date, estimated_hours }
 * @returns {Promise}
 */
export const assignJob = async (jobData) => {
  const response = await api.post('/api/vendors/work-logs', jobData);
  return response.data;
};

/**
 * Get work logs
 * @param {object} filters - { vendor_id }
 * @returns {Promise}
 */
export const getWorkLogs = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.vendor_id) params.append('vendor_id', filters.vendor_id);

  const response = await api.get(`/api/vendors/work-logs?${params.toString()}`);
  return response.data;
};

/**
 * Process a payment to a vendor
 * @param {object} paymentData - Payment data { vendor_id, amount, payment_method, payment_date, notes }
 * @returns {Promise}
 */
export const processPayment = async (paymentData) => {
  const response = await api.post('/api/vendors/payments', paymentData);
  return response.data;
};

/**
 * Get vendor payments
 * @param {object} filters - { vendor_id, status }
 * @returns {Promise}
 */
export const getPayments = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.vendor_id) params.append('vendor_id', filters.vendor_id);
  if (filters.status) params.append('status', filters.status);

  const response = await api.get(`/api/vendors/payments?${params.toString()}`);
  return response.data;
};
